/**
 * About Us Page
 *
 * Information about ClosedLoopDiving and the team behind it.
 */

import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';

export function About() {
  return (
    <Layout>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: 'var(--cld-spacing-xl)' }}>
        {/* Hero Section */}
        <div
          style={{
            backgroundColor: 'var(--cld-color-white)',
            borderRadius: 'var(--cld-radius-lg)',
            padding: 'var(--cld-spacing-2xl)',
            boxShadow: 'var(--cld-shadow-md)',
            marginBottom: 'var(--cld-spacing-xl)',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              color: 'var(--cld-color-primary)',
              fontFamily: 'var(--cld-font-display)',
              fontSize: 'var(--cld-font-size-3xl)',
              fontWeight: 'var(--cld-font-weight-bold)',
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            About ClosedLoopDiving
          </h1>
          <p
            style={{
              color: 'var(--cld-color-gray)',
              fontSize: 'var(--cld-font-size-lg)',
              lineHeight: 1.6,
              maxWidth: '600px',
              margin: '0 auto',
            }}
          >
            Empowering technical divers with modern learning tools to reinforce the skills they learn
            in formal training.
          </p>
        </div>

        {/* Mission Section */}
        <div
          style={{
            backgroundColor: 'var(--cld-color-white)',
            borderRadius: 'var(--cld-radius-lg)',
            padding: 'var(--cld-spacing-xl)',
            boxShadow: 'var(--cld-shadow-md)',
            marginBottom: 'var(--cld-spacing-xl)',
          }}
        >
          <h2
            style={{
              color: 'var(--cld-color-primary)',
              fontFamily: 'var(--cld-font-display)',
              fontSize: 'var(--cld-font-size-xl)',
              fontWeight: 'var(--cld-font-weight-bold)',
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            Our Mission
          </h2>
          <p
            style={{
              color: 'var(--cld-color-gray)',
              lineHeight: 1.7,
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            Technical diving demands precision, knowledge, and constant reinforcement of skills.
            ClosedLoopDiving provides a supplementary online learning platform designed to help divers
            retain and practice the concepts they learn in formal instructor-led courses.
          </p>
          <p
            style={{
              color: 'var(--cld-color-gray)',
              lineHeight: 1.7,
            }}
          >
            Our AI-powered quiz system adapts to your learning style, providing personalized feedback
            and spaced repetition to ensure concepts stick. Whether you're studying gas physics,
            decompression theory, or rebreather operations, we're here to support your journey.
          </p>
        </div>

        {/* Founder Section */}
        <div
          style={{
            backgroundColor: 'var(--cld-color-white)',
            borderRadius: 'var(--cld-radius-lg)',
            padding: 'var(--cld-spacing-xl)',
            boxShadow: 'var(--cld-shadow-md)',
            marginBottom: 'var(--cld-spacing-xl)',
          }}
        >
          <h2
            style={{
              color: 'var(--cld-color-primary)',
              fontFamily: 'var(--cld-font-display)',
              fontSize: 'var(--cld-font-size-xl)',
              fontWeight: 'var(--cld-font-weight-bold)',
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            Meet the Founder
          </h2>

          <div style={{ display: 'flex', gap: 'var(--cld-spacing-lg)', alignItems: 'flex-start' }}>
            {/* Profile Image Placeholder */}
            <div
              style={{
                width: '120px',
                height: '120px',
                borderRadius: 'var(--cld-radius-full)',
                backgroundColor: 'var(--cld-color-primary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <span style={{ fontSize: '3rem' }}>🤿</span>
            </div>

            <div>
              <h3
                style={{
                  color: 'var(--cld-color-primary)',
                  fontFamily: 'var(--cld-font-display)',
                  fontSize: 'var(--cld-font-size-lg)',
                  fontWeight: 'var(--cld-font-weight-semibold)',
                  marginBottom: 'var(--cld-spacing-xs)',
                }}
              >
                Kent Georgeson
              </h3>
              <p
                style={{
                  color: 'var(--cld-color-secondary)',
                  fontSize: 'var(--cld-font-size-sm)',
                  marginBottom: 'var(--cld-spacing-sm)',
                }}
              >
                Founder & Technical Diver
              </p>
              <p
                style={{
                  color: 'var(--cld-color-gray)',
                  lineHeight: 1.7,
                  marginBottom: 'var(--cld-spacing-sm)',
                }}
              >
                With over 30 years of experience in technology and consulting, Kent brings a unique
                perspective to technical diving education. Currently working at GitLab focusing on
                AI integration in software development, he applies the same principles of systematic
                learning and continuous improvement to diving.
              </p>
              <p
                style={{
                  color: 'var(--cld-color-gray)',
                  lineHeight: 1.7,
                  marginBottom: 'var(--cld-spacing-sm)',
                }}
              >
                Kent is a certified Open Water recreational diver on Open Circuit and is currently
                embarking on his technical diving journey with a ScubaForce SF2 rebreather. This
                hands-on experience as a student inspired the creation of ClosedLoopDiving - a
                platform built by a diver, for divers.
              </p>
              <p
                style={{
                  color: 'var(--cld-color-gray)',
                  lineHeight: 1.7,
                }}
              >
                Based in Round Rock, Texas, Kent has lived and worked across Australia, New Zealand,
                and North America, bringing a global perspective to everything he does.
              </p>
            </div>
          </div>
        </div>

        {/* Important Disclaimer */}
        <div
          style={{
            backgroundColor: 'rgba(251, 133, 0, 0.1)',
            border: '1px solid var(--cld-color-accent)',
            borderRadius: 'var(--cld-radius-lg)',
            padding: 'var(--cld-spacing-lg)',
            marginBottom: 'var(--cld-spacing-xl)',
          }}
        >
          <h3
            style={{
              color: 'var(--cld-color-accent)',
              fontFamily: 'var(--cld-font-display)',
              fontSize: 'var(--cld-font-size-base)',
              fontWeight: 'var(--cld-font-weight-bold)',
              marginBottom: 'var(--cld-spacing-sm)',
            }}
          >
            Important Note
          </h3>
          <p
            style={{
              color: 'var(--cld-color-gray)',
              fontSize: 'var(--cld-font-size-sm)',
              lineHeight: 1.6,
            }}
          >
            ClosedLoopDiving is a supplementary study tool only. It does not provide diving
            certification and is not a substitute for formal, instructor-led training from qualified
            diving professionals. Always dive within your certification and experience level.
          </p>
          <Link
            to="/terms"
            style={{
              color: 'var(--cld-color-secondary)',
              fontSize: 'var(--cld-font-size-sm)',
              textDecoration: 'underline',
            }}
          >
            Read our full Terms and Conditions
          </Link>
        </div>

        {/* Contact Section */}
        <div
          style={{
            backgroundColor: 'var(--cld-color-white)',
            borderRadius: 'var(--cld-radius-lg)',
            padding: 'var(--cld-spacing-xl)',
            boxShadow: 'var(--cld-shadow-md)',
            textAlign: 'center',
          }}
        >
          <h2
            style={{
              color: 'var(--cld-color-primary)',
              fontFamily: 'var(--cld-font-display)',
              fontSize: 'var(--cld-font-size-xl)',
              fontWeight: 'var(--cld-font-weight-bold)',
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            Get in Touch
          </h2>
          <p
            style={{
              color: 'var(--cld-color-gray)',
              marginBottom: 'var(--cld-spacing-md)',
            }}
          >
            Have questions or feedback? We'd love to hear from you.
          </p>
          <a
            href="mailto:info@closedloopdiving.com"
            style={{
              display: 'inline-block',
              padding: 'var(--cld-spacing-sm) var(--cld-spacing-lg)',
              backgroundColor: 'var(--cld-color-secondary)',
              color: 'var(--cld-color-white)',
              borderRadius: 'var(--cld-radius-md)',
              textDecoration: 'none',
              fontWeight: 'var(--cld-font-weight-semibold)',
            }}
          >
            Contact Us
          </a>
        </div>
      </div>
    </Layout>
  );
}

export default About;
